import { render, staticRenderFns } from "./GlossaryCategories.vue?vue&type=template&id=39c3a0d5&scoped=true&"
import script from "./GlossaryCategories.vue?vue&type=script&lang=js&"
export * from "./GlossaryCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c3a0d5",
  null
  
)

export default component.exports